import BleedingCards from 'components/BleedingCards';
import WarrantyCard from 'components/WarrantyCard';

import { TEST_ID, WARRANTY_CARD_DATA } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WarrantyCards: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <BleedingCards className={`${className} ${styles.warrantyCards}`} testId={testId}>
        {WARRANTY_CARD_DATA.map(({ description, subtitle, title }, index) => (
            <WarrantyCard
                description={description}
                key={`${title}-${index}`}
                subtitle={subtitle}
                title={title}
            />
        ))}
    </BleedingCards>
);

export default WarrantyCards;
